"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styles_1 = require("../image/styles");
const ImageWithFallback = (0, react_1.forwardRef)((props, ref) => {
    const { src, fallbackSrc, type, ...rest } = props;
    const [currentSrc, setCurrentSrc] = (0, react_1.useState)(src);
    const [isError, setIsError] = (0, react_1.useState)(false);
    const onError = (0, react_1.useCallback)(() => {
        if (fallbackSrc && !isError) {
            setCurrentSrc(fallbackSrc);
            setIsError(true);
        }
    }, [fallbackSrc, isError]);
    return ((0, jsx_runtime_1.jsxs)("picture", { children: [(0, jsx_runtime_1.jsx)("source", { srcSet: src, type: type }), (0, jsx_runtime_1.jsx)(styles_1.StyledImage, { ...rest, src: currentSrc, ...{ onError, ref } })] }));
});
ImageWithFallback.displayName = 'ImageWithFallback';
exports.default = ImageWithFallback;
//# sourceMappingURL=image-with-fallback.js.map